import styled from 'styled-components';

import fonts from 'apps/promo/theme/fonts';
import promoColors from 'apps/promo/theme/promoColors';
import promoMedia from 'apps/promo/theme/promoMedia';
import zIndex from 'apps/promo/theme/zIndex';

export const CountryListDropdown = styled.div`
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: ${zIndex.landingDropdown};
`;
export const SearchInputWrapper = styled.label`
    display: flex;
    align-items: center;
    background: ${promoColors.white};
    border: 1px solid ${promoColors.gray20};
    border-bottom: none;
    border-radius: 8px 8px 0 0;
`;
export const SearchInput = styled.input`
    -webkit-appearance: none;
    outline: none;
    padding: 16px;
    font-size: 18px;
    line-height: 22px;
    border: none;
    border-radius: 8px;
    font-family: ${fonts.gtStandardMMedium};
    color: ${promoColors.gray80};
    flex: 1;

    ${promoMedia.desktop1440} {
        font-size: 21px;
        line-height: 28px;
        padding: 20px;
    }
`;
export const DropdownList = styled.div`
    background-color: ${promoColors.white};
    border: 1px solid ${promoColors.gray20};
    border-top: none;
    border-radius: 0 0 8px 8px;
    overflow: hidden;
    height: ${(props) => (props.$scrollHeight ? `${props.$scrollHeight}px` : null)};
    text-align: left;
`;
export const DropdownListInner = styled.div`
    height: 100%;
    overflow-y: auto;
`;
export const DropdownListHeader = styled.div`
    background: ${promoColors.gray5};
    padding: 8px 16px;
`;
export const DropdownListItem = styled.a`
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    background: ${(props) => (props.$isSelected ? promoColors.gray5 : null)};

    &:hover {
        background: ${promoColors.gray5};
    }

    &:focus-visible {
        background-color: ${promoColors.gray5};
        outline: 1px dashed ${promoColors.gray80};
    }

    ${promoMedia.desktop1440} {
        padding: 20px 24px;
    }
`;
export const DropdownListItemContent = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
`;
export const DropdownNotFound = styled.div`
    padding: 24px;
    text-align: center;
`;
export const DropdownCountryName = styled.div`
    margin-left: 16px;
    margin-right: 8px;

    ${promoMedia.desktop1440} {
        margin-left: 24px;
        margin-right: 12px;
    }
`;
export const DropdownCountryCurrency = styled.div`
    color: ${promoColors.gray40};
    margin-right: 4px;

    &:after {
        content: ', ';
    }
    &:last-child {
        margin-right: 0;
    }
    &:last-child:after {
        content: '';
    }
`;
